import { useEffect } from 'react'
import Loading from './Loading'

/** Full browser navigation (e.g. Jinja employee dashboards outside React Router). */
export default function HardWindowRedirect({ href }: { href: string }) {
  useEffect(() => {
    window.location.replace(href)
  }, [href])
  return <Loading fullScreen text="Загрузка..." />
}
